module.exports = __webpack_public_path__ + "img/symbol_12.2101849c.png";